import { defineMessages } from 'react-intl';

export default defineMessages({
  contentCopied: {
    id: 'app.components.text.TruncateWithTooltip.contentCopied',
    defaultMessage: 'Copied to clipboard',
  },
});
